import clsx from 'clsx';

const Prose = ({ html, className }: { html: string; className?: string }) => {
  return (
    <div
      className={clsx(
        'prose mx-auto max-w-6xl text-base leading-[1.6] text-np-ink prose-headings:mt-8 prose-headings:font-semibold prose-headings:tracking-wide prose-headings:text-np-ink prose-h1:text-5xl prose-h2:text-4xl prose-h3:text-3xl prose-h4:text-2xl prose-h5:text-xl prose-h6:text-lg prose-a:text-np-ink prose-a:underline prose-a:hover:text-np-pink prose-strong:text-np-ink prose-ol:mt-4 prose-ol:list-decimal prose-ol:pl-6 prose-ul:mt-4 prose-ul:list-disc prose-ul:pl-6',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default Prose;
